export default __webpack_public_path__ + "static/media/cover-spotify.6acbc758.png";